import axios from "axios"
import { BASE_URL } from "../utils/endpoints"
import { useNavigate } from "react-router-dom"

export const useAuth = () => {
  const navigate = useNavigate()
  const getAccessToken = () => {
    return document.cookie.split('; ').find(row => row.startsWith('accessToken='))?.split('=')[1]
  }

  const getRefreshToken = () => {
    return document.cookie.split("; ").find(row => row.startsWith('refreshToken'))?.split("=")[1]
  }

  const refreshAccessToken = async () => {
    try {
      const refreshToken = getRefreshToken()
      const response = await axios.post('authentication/token/refresh/', {
        "refresh": refreshToken
      })
      document.cookie = `accessToken=${response.data.access}; SameSite=Strict; Secure; path=/;`
      return response.data.access
    } catch (error) {
      console.error("Failed to refresh access token:", error)
      navigate("/")
      throw error
    }
  }


  const requestWithAuth = async (
    url,
    method = "GET",
    data = null,
    headers = {}
  ) => {
    let accessToken = getAccessToken()

    try {
      if (accessToken) {
        const response = await axios({
          url: `${BASE_URL}${url}`,
          method,
          data,
          headers: {
            ...headers,
            Authorization: `JWT ${accessToken}`,
          },
        })
        return response.data
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        try {
          accessToken = await refreshAccessToken()

          const retryResponse = await axios({
            url: `${BASE_URL}${url}`,
            method,
            data,
            headers: {
              ...headers,
              Authorization: `Bearer ${accessToken}`,
            },
          })
          return retryResponse.data
        } catch (refreshError) {
          throw refreshError
        }
      } else {
        throw error
      }
    }
  }

  return { requestWithAuth }
}